import { render, staticRenderFns } from "./WarehouseItemEditView.vue?vue&type=template&id=6aabcfbd"
import script from "./WarehouseItemEditView.vue?vue&type=script&lang=js"
export * from "./WarehouseItemEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports